module.exports = __webpack_public_path__ + "8f98a5fc8286f2755b4e4222b0eb199d.pdf";